// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QwfG","right":"styles_right__3Y75Y"};